"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getControlledPromise = void 0;
/**
 * Returns a promise with two additional methods:
 * 'resolve' and 'reject'
 */
function getControlledPromise() {
    const bag = {};
    bag.promise = new Promise((res, rej) => {
        bag.resolve = res;
        bag.reject = rej;
    });
    return bag;
}
exports.getControlledPromise = getControlledPromise;
